import{cn}from"../../utils/bem";export var cnBadge=cn("Badge");
//# sourceMappingURL=cn.js.map